import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { PasskeySetup } from '../components/PasskeySetup';

export function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setPasskeyAddress } = useAuth();

  // Get the return URL from location state, default to '/'
  const from = (location.state as { from?: string })?.from || '/';

  const handleAuthenticated = (address: `0x${string}`) => {
    setPasskeyAddress(address);
    navigate(from, { replace: true });
  };

  return (
    <div className="container">
      <PasskeySetup onAuthenticated={handleAuthenticated} />
    </div>
  );
}
